export const DebugInfo = ({
	children,
}: Readonly<{ children: React.ReactNode }>) => {
	if (process.env.WEBPACK_PUBLIC_DISPLAY_DEBUG_INFO !== "true") {
		return <></>;
	} else {
		return <>{children}</>;
	}
};
